/**
 * Centralized donation amount configurations
 * Single source of truth for all donation flows across the platform
 *
 * Usage:
 *   import { DONATION_AMOUNTS, DONATION_CONFIG } from '../constants/donationAmounts';
 *   const amounts = announcement?.suggested_amounts || DONATION_AMOUNTS.default;
 */

/**
 * Standard donation amount presets
 * - default: Used for general announcements, stories, FAB quick donations
 * - events: Used for calendar event sponsorship (typically shorter list)
 * - defaultSelection: The amount pre-selected in donation flows (middle option for anchoring)
 */
export const DONATION_AMOUNTS = {
  // Main donation amounts: $12 (entry), $36 (2× chai), $72 (4× chai), $114 (impact)
  default: [12, 36, 72, 114],

  // Event sponsorship amounts (shorter list for focused selection)
  events: [12, 36, 72],

  // Default pre-selected amount (middle option for better UX anchoring)
  defaultSelection: 36
};

/**
 * Donation UI/UX configuration
 * Controls visual elements and messaging in donation components
 */
export const DONATION_CONFIG = {
  // Whether to show tax-deductible helper text
  showTaxDeductibleText: true,

  // The helper text message (with emoji for visibility)
  taxDeductibleMessage: '💡 All donations are tax-deductible',

  // Whether to show "Most Popular" badge on suggested amounts (disabled per UX requirements)
  enableMostPopularBadge: false
};

/**
 * Helper function to format amounts for display
 * @param {number[]} amounts - Array of numeric amounts
 * @returns {Array<{value: number, label: string}>} Formatted amount objects
 */
export const formatDonationAmounts = (amounts) => {
  return amounts.map(amount => ({
    value: amount,
    label: `$${amount}`
  }));
};
